import {INSTALLER_COMPANIES_ERROR,INSTALLER_COMPANIES_START, INSTALLER_COMPANIES_SUCCESS, COMMERCIAL_OFFERS_ERROR, COMMERCIAL_OFFERS_SUCCESS, FILTER_SHOP_ERROR, FILTER_SHOP_SUCCESS, PRODUCTS_ERROR, PRODUCTS_SUCCESS, SOFTWAREVERSIONS_SUCCESS, SOFTWAREVERSIONS_ERROR, UPLOAD_START, UPLOAD_SUCCESS, UPLOAD_ERROR, ARTICLES_FOR_PRODUCT_SUCCESS, ARTICLES_FOR_PRODUCT_ERROR, LOAD_MANAGER_SUCCESS, LOAD_MANAGER_ERROR, LOAD_DOCUMENTS_SUCCESS, LOAD_DOCUMENTS_ERROR, LOGIN_BACKEND_PICKED, LOGIN_SELECT_DEFAULT_BACKEND, CHANGE_TAB, LOGOUT_USER} from '../constants/Constants.js';

let initialstate = {
    installerCompanies: [],
    commercialOffers: [],
    products: [],
    articles: [],
    softwareVersions: [],
    binary: {
        inProgress: false
    },
    documents: [],
    tab: 0
};

export default function ZehnderStore(state = initialstate, action = {}) {
    console.log(action.type);
    switch (action.type) {
        case FILTER_SHOP_SUCCESS:
            return {
                ...state,
                filterShops: action.filterShops
            };
        case FILTER_SHOP_ERROR:
            return {
                ...state,
                filterShops: []
            };
        case COMMERCIAL_OFFERS_SUCCESS:
            return {
                ...state,
                commercialOffers: action.commercialOffers
            };
        case COMMERCIAL_OFFERS_ERROR:
            return {
                ...state,
                commercialOffers: []
            };
      case INSTALLER_COMPANIES_START:
            return {
              ...state,
              installerCompanies: []
            }
        case INSTALLER_COMPANIES_SUCCESS:
            return {
                ...state,
                installerCompanies: action.installerCompanies
            };
        case INSTALLER_COMPANIES_ERROR:
            return {
                ...state,
                installerCompanies: []
            };
        case PRODUCTS_SUCCESS:
            return {
                ...state,
                products: action.products
            };
        case PRODUCTS_ERROR:
            return {
                ...state,
                products: []
            };
        case SOFTWAREVERSIONS_SUCCESS:
            return {
                ...state,
                softwareVersions: action.softwareVersions
            };
        case SOFTWAREVERSIONS_ERROR:
            return {
                ...state,
                softwareVersions: []
            };
        case UPLOAD_START:
            return {
                ...state,
                binary: {inProgress: true}
            };
        case UPLOAD_SUCCESS:
            return {
                ...state,
                binary: {inProgress: false}
            };
        case UPLOAD_ERROR:
            return {
                ...state,
                binary: {inProgress: false}
            };
        case ARTICLES_FOR_PRODUCT_SUCCESS:
            let flags = [], unique = [], l = action.articles.length, i;
            for (i = 0; i < l; i++) {
                let compareString = action.articles[i].articleID + action.articles[i].name + action.articles[i].hwVersionId;

                if (flags[compareString]) {
                    continue;
                }
                flags[compareString] = true;
                unique.push(action.articles[i]);
            }
            return {
                ...state,
                articles: unique
            };
        case ARTICLES_FOR_PRODUCT_ERROR:
            return {
                ...state,
                articles: []
            };
        case LOAD_MANAGER_SUCCESS:
            return {
                ...state,
                manager: action.manager
            };
        case LOAD_MANAGER_ERROR:
            return {
                ...state,
                manager: {}
            };
        case LOAD_DOCUMENTS_SUCCESS:
            return {
                ...state,
                documents: action.documents
            };
        case LOAD_DOCUMENTS_ERROR:
            return {
                ...state,
                documents: []
            };
        case LOGIN_BACKEND_PICKED:
        case LOGOUT_USER:
            return {
                ...state,
                tab: 0
            };
        case CHANGE_TAB:
            return {
                ...state,
                tab: action.tab
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// /src/reducers/ZehnderReducer.js